// Coalescência de refetch disparado por evento realtime (gargalos-restantes.md item 4, repo
// WootDash). Admins estão no grupo "painel" do SignalR e recebem TODO evento do sistema —
// sem isto, cada mensagem de qualquer conversa virava um refetch completo do Dashboard em
// cada admin conectado. Com isto, uma rajada de N eventos custa no máximo 1 rodada a cada
// minIntervalMs por admin, independente de N.
//
// Semântica:
// - 1º evento depois de um período quieto roda NA HORA (latência de mensagem isolada igual
//   a antes — o admin não espera a janela pra ver a primeira mudança).
// - Eventos dentro da janela viram UMA rodada ao fim dela (nunca perde o último estado).
// - Nunca roda duas vezes em paralelo: evento durante uma rodada em andamento agenda outra
//   pra depois dela (evita resposta antiga sobrescrevendo a nova).
export interface CoalescedRunner {
  trigger(): void
  cancel(): void
}

export function createCoalescedRunner(
  task: () => unknown,
  minIntervalMs: number,
  now: () => number = Date.now,
): CoalescedRunner {
  let lastStart = Number.NEGATIVE_INFINITY
  let running = false
  let pendingAfterRun = false
  let timer: ReturnType<typeof setTimeout> | null = null

  function run() {
    timer = null
    running = true
    lastStart = now()
    Promise.resolve()
      .then(task)
      .catch(() => { /* quem chama trata o próprio erro (ex: dataStale); aqui só não trava */ })
      .finally(() => {
        running = false
        if (pendingAfterRun) {
          pendingAfterRun = false
          schedule()
        }
      })
  }

  function schedule() {
    if (running) { pendingAfterRun = true; return }
    if (timer) return
    const wait = lastStart + minIntervalMs - now()
    if (wait <= 0) run()
    else timer = setTimeout(run, wait)
  }

  return {
    trigger: schedule,
    cancel() {
      if (timer) { clearTimeout(timer); timer = null }
      pendingAfterRun = false
    },
  }
}
